
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as edoBRKXBFsmW7vzzTG1v7JtTVr7DdLtj5dRc5o264wpg_0Meta } from "/var/www/2025-07-29_16_32/pages/edo.vue?macro=true";
import { default as helpSgbZoFCAvivvSHSAWAOQXGb8Jw4hnAHVbMnNFUN8sr0Meta } from "/var/www/2025-07-29_16_32/pages/help.vue?macro=true";
import { default as cargoDkdn9yFw2WsC8CiVLFkdbpxbkrNqUoBjqJ5VnGNSeHcMeta } from "/var/www/2025-07-29_16_32/pages/cargo.vue?macro=true";
import { default as indexEZNQlxUFUHcL2PTKcADhl2_45dVlg_3q1ygJJbX5jGmJ0Meta } from "/var/www/2025-07-29_16_32/pages/index.vue?macro=true";
import { default as _91slug_93fAERDOk_45c3bxD9AgyRVrA2pC_LKcLRz0OyLdgAIWgQYMeta } from "/var/www/2025-07-29_16_32/pages/[slug].vue?macro=true";
import { default as cookievM27a9HbuPvmFCIbPiIzsUhmqZIVNSSHhpNjvQWCNRUMeta } from "/var/www/2025-07-29_16_32/pages/cookie.vue?macro=true";
import { default as surveypDJQ8mwLQeCOJ_45dKqasE0DfLvMDizjPimbS6oTD4A_45MMeta } from "/var/www/2025-07-29_16_32/pages/survey.vue?macro=true";
import { default as belarusQrkGGXCaT7rFoOPao4XeDEdjod9s7WBvYIpntiO4tesMeta } from "/var/www/2025-07-29_16_32/pages/belarus.vue?macro=true";
import { default as bonusesG_oL_45uw4hVKuPaG2K2Uf0CYSiieOdK3y_F4P0wzF2KsMeta } from "/var/www/2025-07-29_16_32/pages/bonuses.vue?macro=true";
import { default as apiKRDNx8g50p_452qIg2cGBYr6oawtvEyF9Ahp4wnAeBMvIMeta } from "/var/www/2025-07-29_16_32/pages/dev/api.vue?macro=true";
import { default as cmssZVSOEp_hjEN__454Rp1dBiw0anCluFYkj409bzzKmEBIMeta } from "/var/www/2025-07-29_16_32/pages/dev/cms.vue?macro=true";
import { default as konkursPhMaiSfuUaO_wecgp9bE_OXYiLYUkhuLQIZV_45T4yIfEMeta } from "/var/www/2025-07-29_16_32/pages/konkurs.vue?macro=true";
import { default as successqkSCCX_DrylQtjRPHFCI3HvZGyWyOEwpgP1XDcpTaoAMeta } from "/var/www/2025-07-29_16_32/pages/success.vue?macro=true";
import { default as vacancygoV3fwMzHghTkmaMS0tjEYJmtUPFPaf8zjbb_h11iogMeta } from "/var/www/2025-07-29_16_32/pages/vacancy.vue?macro=true";
import { default as contactsoCxutnBEJB96cl69gYPgd7Gn1HaucrpXVnjmQiUKjIkMeta } from "/var/www/2025-07-29_16_32/pages/contacts.vue?macro=true";
import { default as giveaway1Hs2wNumloYflO4k1uzfQdKHZ_a9PYtnMG0pUoOicF4Meta } from "/var/www/2025-07-29_16_32/pages/giveaway.vue?macro=true";
import { default as guide_45lkY6YUaQKKWVWOJct7_45e6odPbmvQZveyKEFs3zZom2W6AMeta } from "/var/www/2025-07-29_16_32/pages/guide-lk.vue?macro=true";
import { default as servicesobXUciE_45g6lz6sR5ROu0prBNeEs4eJOZdU47cSp4i6AMeta } from "/var/www/2025-07-29_16_32/pages/services.vue?macro=true";
import { default as telegram8CZ_2viZOraoEiSTmpbQ019AJbTsq1UNcyDw9nF3UiAMeta } from "/var/www/2025-07-29_16_32/pages/telegram.vue?macro=true";
import { default as documentsHCkK31dH3xtPtWTo6EQWwumjvVFzfJvOiPQ_tXZ9Dt0Meta } from "/var/www/2025-07-29_16_32/pages/documents.vue?macro=true";
import { default as franchisevKFm0gdl07oNGVs2thF9H2Xu0OCb9eVzza4SXaaOOfEMeta } from "/var/www/2025-07-29_16_32/pages/franchise.vue?macro=true";
import { default as insuranceBMl2FAUMCixX1xIYk8NI0YC5rtIGQrXpvwYJlUMR8doMeta } from "/var/www/2025-07-29_16_32/pages/insurance.vue?macro=true";
import { default as kirghiziaIW4S0M8H3htwPdB2ipYQ_DRlR_ymdAMZhqfp1t3ydmIMeta } from "/var/www/2025-07-29_16_32/pages/kirghizia.vue?macro=true";
import { default as mapSchemeu_IZCff2E1EIBWxq5d1qRPuTI5Gdkd_45ZXcFod6rKuTcMeta } from "/var/www/2025-07-29_16_32/pages/mapScheme.vue?macro=true";
import { default as _91id_93yIdeObKT8rn4JbFTVE70BlDCLXjAKEkeQT6e0i20eWAMeta } from "/var/www/2025-07-29_16_32/pages/news/[id].vue?macro=true";
import { default as return_45sdMEDXAfbn_45dvNhIWwvpvYdH5qPKEFVx_CohLeADE5j08Meta } from "/var/www/2025-07-29_16_32/pages/return-sd.vue?macro=true";
import { default as smsClient430NixCnvoYmp4x2d_PsYqW61HgTC05r2KW37gjbsNoMeta } from "/var/www/2025-07-29_16_32/pages/smsClient.vue?macro=true";
import { default as terminalskGXG8ksSY_ACBHV9xRdjRfo91fuBEAHlksd2OCUFQsgMeta } from "/var/www/2025-07-29_16_32/pages/terminals.vue?macro=true";
import { default as iframeIsdraycpbgnl_0pH8KTcDX2OecO7ynxw2MboUixMyD4Meta } from "/var/www/2025-07-29_16_32/pages/dev/iframe.vue?macro=true";
import { default as directionsbl55AI7dBmHSiiPSTcf_oyLEcnNNJLqsns7Gdm45a1IMeta } from "/var/www/2025-07-29_16_32/pages/directions.vue?macro=true";
import { default as kazakhstan_45Yxyrz_wnjXZuzVj10_TK_e53KSvU_46w50jM8ijRukMeta } from "/var/www/2025-07-29_16_32/pages/kazakhstan.vue?macro=true";
import { default as indexhiLXTsq_bK6LL2i6AUW_450Uu_tHf3oKgLTfHasHRTiWwMeta } from "/var/www/2025-07-29_16_32/pages/news/index.vue?macro=true";
import { default as svg55_697zYz8hE_45FzyRqAdXI2XKzYPt9KS20_45i_GVmUycMeta } from "/var/www/2025-07-29_16_32/pages/ui-kit/svg.vue?macro=true";
import { default as vzpay_45failS428TUbFt9ckzoWhVovebL687NdWh8v4tvCgaPhhYWgMeta } from "/var/www/2025-07-29_16_32/pages/vzpay-fail.vue?macro=true";
import { default as constructorIeMOLuS8oh8LSfNz0xwZHlx3rlr2yt6i7pl5tNZzBUMMeta } from "/var/www/2025-07-29_16_32/pages/constructor.vue?macro=true";
import { default as indexG5uEdfK9D_Yk5cjyjTOS58x15o7501dmKmg2JVR974QMeta } from "/var/www/2025-07-29_16_32/pages/gifts/index.vue?macro=true";
import { default as informationCZS_45gxvbQrNN8ZlvYpc3_45i5Zdnd3yZQooqgGz_45u6008Meta } from "/var/www/2025-07-29_16_32/pages/information.vue?macro=true";
import { default as lightT7fWefDYQDTToxwmYKU3OTPZPM6hXxIFYNNNVdPVSUsMeta } from "/var/www/2025-07-29_16_32/pages/order/light.vue?macro=true";
import { default as claim_45filingPxicsxZrVLgJu6EGuMR_n_45xdRNES8hQ1yZ56T_3u1NkMeta } from "/var/www/2025-07-29_16_32/pages/claim-filing.vue?macro=true";
import { default as _91type_93MR5j4_FG4golKFvZp5j2ACTVf6zTq_45x4MwGqKb56VHYMeta } from "/var/www/2025-07-29_16_32/pages/gifts/[type].vue?macro=true";
import { default as marketplacesDvB3Qdw3jRV2FHDSbbx9gIbfa1IONDhsikWjB_nR5P4Meta } from "/var/www/2025-07-29_16_32/pages/marketplaces.vue?macro=true";
import { default as networkshopsvVOV_45zsJirtJ3ebGpe1h5IpHU4z_s28dv7CiHPSAZ_454Meta } from "/var/www/2025-07-29_16_32/pages/networkshops.vue?macro=true";
import { default as online_45storeCBvWpUPVFCSlHPO_45i41Rjn4B0BZDhLRFKC0O89lLI6EMeta } from "/var/www/2025-07-29_16_32/pages/online-store.vue?macro=true";
import { default as managey_18eS8Q6RCZt_457mTyKBR_45R6SueExdLo03Hmv_RrhNQMeta } from "/var/www/2025-07-29_16_32/pages/order/manage.vue?macro=true";
import { default as registration_PSmJzBeo26jS7GCsEwuxw7AMt_45nsklrHlEJuVKFQZgMeta } from "/var/www/2025-07-29_16_32/pages/registration.vue?macro=true";
import { default as safe_45custody5_45ZE4KrqiCFV7TqyFheb3hYIs_456LMZyBg3TYTCzLsQsMeta } from "/var/www/2025-07-29_16_32/pages/safe-custody.vue?macro=true";
import { default as image7wiE3g7P4qeb6yOzgWsxT_Um3_45kTersOT43yVkL2AEcMeta } from "/var/www/2025-07-29_16_32/pages/ui-kit/image.vue?macro=true";
import { default as indexo0NQ2yHFGlTG9W_45Pk59SVkXxDYDjxvSNgNuvCGWT96wMeta } from "/var/www/2025-07-29_16_32/pages/ui-kit/index.vue?macro=true";
import { default as bagKWHB_zMv43vuHbZLWJV__CN_45crU9e23N6EBbqvly61YMeta } from "/var/www/2025-07-29_16_32/pages/wrapping/bag.vue?macro=true";
import { default as box07sr2VvjcbdhLu337v5wpVcyojhhhFIjCgSqRYjNTWcMeta } from "/var/www/2025-07-29_16_32/pages/wrapping/box.vue?macro=true";
import { default as cargo_45loadingHmEOWyUb8QUwXJuW2NIhy9yRK_45vLbzl4othQvjAJaPsMeta } from "/var/www/2025-07-29_16_32/pages/cargo-loading.vue?macro=true";
import { default as happybirthdayhDIxfB6kNBAkddKjPvduZ00jaxp_b4Cd_45zndrlmxXm4Meta } from "/var/www/2025-07-29_16_32/pages/happybirthday.vue?macro=true";
import { default as manageYrSUTMTPGqYrjp_eI8qQCl9QXP8Huj5TQBtT_oQn_lsMeta } from "/var/www/2025-07-29_16_32/pages/iframe/manage.vue?macro=true";
import { default as auth9kB3PDdBOOEPVwSCGT_45TIoe2OJoJCrRh3yWevGhzvzEMeta } from "/var/www/2025-07-29_16_32/pages/personal/auth.vue?macro=true";
import { default as indexHbyCVkmaQ30wMxQqvLixUa1YTA6Y8sPJGIRc6DTOCN0Meta } from "/var/www/2025-07-29_16_32/pages/tariffs/index.vue?macro=true";
import { default as publicnYOzQlhKWFSm2mxydWAiujYx9O_45z_UGQQF8cbpvbYVMMeta } from "/var/www/2025-07-29_16_32/pages/ui-kit/public.vue?macro=true";
import { default as already_45answerbN08uRK5CYmVW0z5Ytje3dTXYXYRhSQHLqUxnfEPJL4Meta } from "/var/www/2025-07-29_16_32/pages/already-answer.vue?macro=true";
import { default as tariffs7NXaEdMWmlxmiKR2cyqwE_45_4552uAXn_xwX7uui4nsht4Meta } from "/var/www/2025-07-29_16_32/pages/iframe/tariffs.vue?macro=true";
import { default as _91id_93p8rCULJondKqxZJJ8do5cffteEpsdtkJSr0ruxSa7QwMeta } from "/var/www/2025-07-29_16_32/pages/order/pay/[id].vue?macro=true";
import { default as indexwDDjgMf2rnQ_4Fr7iK918a_45ZEwmJ58m8iSgBnQC4k3IMeta } from "/var/www/2025-07-29_16_32/pages/personal/index.vue?macro=true";
import { default as _91hash_93JEsIW0hBSEeO8iyrH6Hs0ds_45QjWzyEBe_45ddCvG9apXsMeta } from "/var/www/2025-07-29_16_32/pages/welcome/[hash].vue?macro=true";
import { default as indexUxWovLkKWNkEXnWDdfCkZa3ZDz2uJ9fwvXb0eyhuY_450Meta } from "/var/www/2025-07-29_16_32/pages/wrapping/index.vue?macro=true";
import { default as delivery_45russiaj8eYAZ5kLwD_450Vz3h6nO_h7K4j26wV8T4WxoTRLHWHAMeta } from "/var/www/2025-07-29_16_32/pages/delivery-russia.vue?macro=true";
import { default as payment_45methodsIX3bAsD2khFiOvmTxIa1nBydQ1ZhU5HZ58Ov7DUfCbcMeta } from "/var/www/2025-07-29_16_32/pages/payment-methods.vue?macro=true";
import { default as qr_45infocd7osBhzvk6FqttaZPs3yP9k0M_ZvZiaYsMARO_45AKL0Meta } from "/var/www/2025-07-29_16_32/pages/payment/qr-info.vue?macro=true";
import { default as successMHD4bAoduwzRArUbS_45SqvkwJKeQYSOkORfxSh6Xw1VwMeta } from "/var/www/2025-07-29_16_32/pages/payment/success.vue?macro=true";
import { default as importEvzengNLt30HbTtw7quj5tOQ6WSEzYBcDwYe0DW8Fu8Meta } from "/var/www/2025-07-29_16_32/pages/personal/import.vue?macro=true";
import { default as logoutj57kBWi4E9Rdd_jDMvorCaBf5OEbjbdVR_rHv183KUYMeta } from "/var/www/2025-07-29_16_32/pages/personal/logout.vue?macro=true";
import { default as address_45delivery72_45w9IUagCat9IV0pa_45vT_45_JeXVAmIOWFpIMhibcvFwMeta } from "/var/www/2025-07-29_16_32/pages/address-delivery.vue?macro=true";
import { default as cash_45on_45deliveryZCNTTscCW_45vadH9O2a0_45Bb0U0SMJV8_45747Lqv94JMJsMeta } from "/var/www/2025-07-29_16_32/pages/cash-on-delivery.vue?macro=true";
import { default as happynewyear20240gJTpL1tWKViEWF56Q7_45_45OSdv_45eDP1riNzPPx9bDvEcMeta } from "/var/www/2025-07-29_16_32/pages/happynewyear2024.vue?macro=true";
import { default as ozonoinsdbviUj3Zo7H4UXUs2W6BDKDQPwOOyLqDWRYslZAMeta } from "/var/www/2025-07-29_16_32/pages/marketplace/ozon.vue?macro=true";
import { default as pay_45failMD9CT5ISyapbDoFrzD6JcHdGb5gLSP7bN2BxLmAh6iMMeta } from "/var/www/2025-07-29_16_32/pages/payment/pay-fail.vue?macro=true";
import { default as accountspeWv_tk78JdECWzem_z3KHrq299vLuTmBY00tfybM8Meta } from "/var/www/2025-07-29_16_32/pages/personal/account.vue?macro=true";
import { default as prohibited_45goods0oVW8mkmggutVBZ5AjjlDxUMX7CZfBqFM0eJMx746xMMeta } from "/var/www/2025-07-29_16_32/pages/prohibited-goods.vue?macro=true";
import { default as survey_45completedfYWr5whuVinx8d6M_45ijZJUhigdGRWk7OT6E_6ZclmtAMeta } from "/var/www/2025-07-29_16_32/pages/survey-completed.vue?macro=true";
import { default as direction8U_45Y0_45dkaBcEbfFDQsQmm_JSD2ilnc3EfzMhfCQvIc4Meta } from "/var/www/2025-07-29_16_32/pages/ui-kit/direction.vue?macro=true";
import { default as free_45group_45pickupxtd9PPqcrESN_ghCr17jq414g0hH291pjSVBOxblFjMMeta } from "/var/www/2025-07-29_16_32/pages/free-group-pickup.vue?macro=true";
import { default as free_45pickup_45cargozww8Okbk1bBP127Sy9uVFnKNrHPe7jBVWT32uRzHhlgMeta } from "/var/www/2025-07-29_16_32/pages/free-pickup-cargo.vue?macro=true";
import { default as calculatorxYLEH9HcwxmaYJuT45SbiOrdoROCYwy3DtABEuBEgGQMeta } from "/var/www/2025-07-29_16_32/pages/iframe/calculator.vue?macro=true";
import { default as merch_45for_45bonusesnwn10Ht0v7dFsjhiH3UnEFJRMD5lSWQtdQlueokenygMeta } from "/var/www/2025-07-29_16_32/pages/merch-for-bonuses.vue?macro=true";
import { default as _91id_93oDoj0zv3Xe_QQd4pjz11TnKx3_gjQuHJDuWLDDb31yQMeta } from "/var/www/2025-07-29_16_32/pages/order/pay/qr/[id].vue?macro=true";
import { default as card_45infoWcM_45Sb82o99KZqJXonBGc_RNJRpMpdSB8_45N_hLmA85wMeta } from "/var/www/2025-07-29_16_32/pages/payment/card-info.vue?macro=true";
import { default as discount41O_45F57cLWNumuqzam6NiEsaeGKGRlP3saRG5pBnvgcMeta } from "/var/www/2025-07-29_16_32/pages/personal/discount.vue?macro=true";
import { default as hard_45box2Ljoyv3axd4kYS_45Kw0Qx0yWIK9_RjNAoV_45vSXuj9ZA8Meta } from "/var/www/2025-07-29_16_32/pages/wrapping/hard-box.vue?macro=true";
import { default as forwarding_45receiptrrnuGAHa_45RbN_45kwm8_by_45qmgrtXyhnc59mwXYgmjNgUMeta } from "/var/www/2025-07-29_16_32/pages/forwarding-receipt.vue?macro=true";
import { default as mailClient10201917abPrDoDNkgRTS623gPKzKLE0nTgEx5jz27haA_45wnd50Meta } from "/var/www/2025-07-29_16_32/pages/mailClient10201917.vue?macro=true";
import { default as mobile_45applicationCNBhZUNkXID8Vbi1RkVBWqDfzfWJtTN4I9mQaIERqXQMeta } from "/var/www/2025-07-29_16_32/pages/mobile-application.vue?macro=true";
import { default as indexEq3kCuOjTxuWTZgW_dUHf8A6SZCcBI0bCLuWFYUoXU8Meta } from "/var/www/2025-07-29_16_32/pages/order/create/index.vue?macro=true";
import { default as indexcRd8izm18Sx9Nr9s5agwe1EOIBbMgP7zA0HrNkCclNQMeta } from "/var/www/2025-07-29_16_32/pages/run-schedule/index.vue?macro=true";
import { default as boatpRn4gwDa7ARue9HjJPUec7WDuujJPK7tuZUSnq4rxoEMeta } from "/var/www/2025-07-29_16_32/pages/shippingtypes/boat.vue?macro=true";
import { default as sofaIe2ffyDf6bvsTu_45BRV82tGstxxWqvDON0QgcQ4yr65MMeta } from "/var/www/2025-07-29_16_32/pages/shippingtypes/sofa.vue?macro=true";
import { default as _91location_93uo2ygnW6aW6FNg2tepTEi_45uBckkQCimz_AaswEvdUdwMeta } from "/var/www/2025-07-29_16_32/pages/tariffs/[location].vue?macro=true";
import { default as cardboardvW3j3VthDjPGkRsSvnRulDGJ_V4YwfyM2mvnNGmH4bUMeta } from "/var/www/2025-07-29_16_32/pages/wrapping/cardboard.vue?macro=true";
import { default as promocodesi7D4vzz2QJOeD5DHNVTvDirmiqHM3gSDDqJWjSG1REMMeta } from "/var/www/2025-07-29_16_32/pages/personal/promocodes.vue?macro=true";
import { default as benchmMeXmDEg6kZbGthm27VCls5vtbPMoveG6sbPVgrJqg8Meta } from "/var/www/2025-07-29_16_32/pages/shippingtypes/bench.vue?macro=true";
import { default as bookstRXnBGRHQy922K1RTzAwxPo6J5_Wks91WXbf6F2lwYQMeta } from "/var/www/2025-07-29_16_32/pages/shippingtypes/books.vue?macro=true";
import { default as cablebElom830yJj0I_pCeJ_VFgiXBArlDv5D2djaWkC4YbwMeta } from "/var/www/2025-07-29_16_32/pages/shippingtypes/cable.vue?macro=true";
import { default as chairVyV5pP18athIiUag_518ExMqa4eyZLawN8Kv_q0SRoYMeta } from "/var/www/2025-07-29_16_32/pages/shippingtypes/chair.vue?macro=true";
import { default as goods4fMlq9_45UlwDUXujqrAwHI9zMB8RCduxEb4JO1p5VsMYMeta } from "/var/www/2025-07-29_16_32/pages/shippingtypes/goods.vue?macro=true";
import { default as indexlmGW_u_MYKk6GYdNnhLtHu5VH9xSUKngcuFNnnE9B18Meta } from "/var/www/2025-07-29_16_32/pages/shippingtypes/index.vue?macro=true";
import { default as metalWWMYoQThfm3ZwnkqXFsXnghYjngdEd_SH1qzQfAMeYsMeta } from "/var/www/2025-07-29_16_32/pages/shippingtypes/metal.vue?macro=true";
import { default as piano7IaaVxtzPjSZsK_45lbLPRrpSditsL5OfkQt_45BUw93A7UMeta } from "/var/www/2025-07-29_16_32/pages/shippingtypes/piano.vue?macro=true";
import { default as pipes1XBcICzadLkWRDnWRx99Lp_451Uq5vC_Kncgc8_45SqLZX4Meta } from "/var/www/2025-07-29_16_32/pages/shippingtypes/pipes.vue?macro=true";
import { default as toolsi6KMT2NOk_vPqIqFy9DR_yctWo4hHIK5oqSnLtIhuiUMeta } from "/var/www/2025-07-29_16_32/pages/shippingtypes/tools.vue?macro=true";
import { default as pallet_45boxUxd2LYgeo4y76jfgyVSp5XrjpFJ9S_bJ4XZQ0KxMP1cMeta } from "/var/www/2025-07-29_16_32/pages/wrapping/pallet-box.vue?macro=true";
import { default as _91tab_933qCBhm_4d_kzsVyCzI96mjUgdGw8zin0I3rbexuD5IUMeta } from "/var/www/2025-07-29_16_32/pages/personal/bonus/[tab].vue?macro=true";
import { default as print9ZYYT_tpcpq8MbsvsaAhHH8XwxpT60T5V2MjZF46_78Meta } from "/var/www/2025-07-29_16_32/pages/personal/order/print.vue?macro=true";
import { default as dishes6i_pSENW6_45phRKJ8o5ii8GbCTmYLKpur_458yNaNrJbAYMeta } from "/var/www/2025-07-29_16_32/pages/shippingtypes/dishes.vue?macro=true";
import { default as engine3aB7p2du_459z20dWYGpWdoJ18nYlyS38bJajQ0whSOA4Meta } from "/var/www/2025-07-29_16_32/pages/shippingtypes/engine.vue?macro=true";
import { default as lumber3KZqvd6PzbqDADLBrAfUkGNXeC33ilvopFbuy66L2OAMeta } from "/var/www/2025-07-29_16_32/pages/shippingtypes/lumber.vue?macro=true";
import { default as wheelsPzTpnUxBBW4KyKGbIogGJrhMUU2nuWAWxXEHgNjLQCoMeta } from "/var/www/2025-07-29_16_32/pages/shippingtypes/wheels.vue?macro=true";
import { default as bubble_45film3kTPCtBM8oDDjBeSNK0JGmcMjOno3mnV1pOI7JyG55oMeta } from "/var/www/2025-07-29_16_32/pages/wrapping/bubble-film.vue?macro=true";
import { default as palletisingqcoEHvoGaw4vxPwvR5Hhdd8V0W_R8Vfv7rz_45NhiChDAMeta } from "/var/www/2025-07-29_16_32/pages/wrapping/palletising.vue?macro=true";
import { default as fast_45delivery_45capitalf4T8EoTRhRp8zuWLSKA89d0mRkEImsW7Sb2L0qtrKRQMeta } from "/var/www/2025-07-29_16_32/pages/fast-delivery-capital.vue?macro=true";
import { default as _91guid_93BGQ6znANQ9GjdsNFtn3EuW5mZewyDa_fQjdDnxZJ5wgMeta } from "/var/www/2025-07-29_16_32/pages/personal/order/[guid].vue?macro=true";
import { default as createpvDxW9cthosJv6hQFPSZNI8d2rsq5fvxrpuTKprmlO0Meta } from "/var/www/2025-07-29_16_32/pages/personal/order/create.vue?macro=true";
import { default as barrelsWftZ2WsjlSsi4jL1By1lIP3RpVeXR8XLoC2jeJWt7GYMeta } from "/var/www/2025-07-29_16_32/pages/shippingtypes/barrels.vue?macro=true";
import { default as clothesdofSuqtF9CM4OL20W_sPXrD1XnYnzvy26mrSJbGjhRkMeta } from "/var/www/2025-07-29_16_32/pages/shippingtypes/clothes.vue?macro=true";
import { default as fragileXj2TXKQMOXzqZszNFX0boY41UmU2mpYrz6dWHSzZ2AoMeta } from "/var/www/2025-07-29_16_32/pages/shippingtypes/fragile.vue?macro=true";
import { default as trailere7rkPPZRenmA195vorLUgIZUFObqGaCy0kLcKDUwTLgMeta } from "/var/www/2025-07-29_16_32/pages/shippingtypes/trailer.vue?macro=true";
import { default as safe_45packagey4_45PMQ5mw5U2j1xGJXcyxBl577nqchtOZYnxducnoj0Meta } from "/var/www/2025-07-29_16_32/pages/wrapping/safe-package.vue?macro=true";
import { default as bepaid_45successalbFDKQs4KqyYy2K4Z3XK8qgcBmtNF4_MiUKargo32wMeta } from "/var/www/2025-07-29_16_32/pages/payment/bepaid-success.vue?macro=true";
import { default as extra_45packagehuJTYQLN_45u0gkyYA_45IEaFT84D6_45Dm5mNeEAtZaLIZowMeta } from "/var/www/2025-07-29_16_32/pages/wrapping/extra-package.vue?macro=true";
import { default as wildberriesQ86lvCGBXkTXWEdVDiB9VgaRkk7BJlNjwJxPcUqn0gcMeta } from "/var/www/2025-07-29_16_32/pages/marketplace/wildberries.vue?macro=true";
import { default as _91guid_93mhOysoEmMFbxIHagDlcip92ZSYrxWEiY8iXwKSJyD_45EMeta } from "/var/www/2025-07-29_16_32/pages/order/administer/[guid].vue?macro=true";
import { default as _91location_93fL3Sb6jcPtweOAAdjlo4oXvJYzGN0QYtyKQJKOAx2jkMeta } from "/var/www/2025-07-29_16_32/pages/run-schedule/[location].vue?macro=true";
import { default as furnituretplK_45ZWPDLdtaHaob9pijqvBqCaLeGLLXb3GPMiutg0Meta } from "/var/www/2025-07-29_16_32/pages/shippingtypes/furniture.vue?macro=true";
import { default as oversized_grizpZ_45MQNYcazgRZtyiBdSIIbd8RFGJU8vg1nWYGYMeta } from "/var/www/2025-07-29_16_32/pages/shippingtypes/oversized.vue?macro=true";
import { default as quad_45bike_n7Ck1DrO4o3AnzV3iKLWMwD0u69x4ZCYJdUAxmbIGIMeta } from "/var/www/2025-07-29_16_32/pages/shippingtypes/quad-bike.vue?macro=true";
import { default as _91locations_93WcIouUNEpcpoJnz0fPD8IKSRJdCPfTobVx_4544wSw2KgMeta } from "/var/www/2025-07-29_16_32/pages/order/create/[locations].vue?macro=true";
import { default as _91_46_46_46tab_9345WVe7o4nlVUFz0w4708weB2_P_45nhE1jCqQOQ50e9kgMeta } from "/var/www/2025-07-29_16_32/pages/personal/orders/[...tab].vue?macro=true";
import { default as auto_45partsP_45KNE3b4T1arxlBtmUhG4ZOUQFeaWUYJxiAHmifrSDAMeta } from "/var/www/2025-07-29_16_32/pages/shippingtypes/auto-parts.vue?macro=true";
import { default as newspapersFRGsAeqVuXhLbWG_45R_KZZuWJ2yKbH6Dni4VZ4K6SJLcMeta } from "/var/www/2025-07-29_16_32/pages/shippingtypes/newspapers.vue?macro=true";
import { default as smallcargogE1NiP4jDELq7sQC0lqsUQhHgU1bOHr8jG_K05Y0_b0Meta } from "/var/www/2025-07-29_16_32/pages/shippingtypes/smallcargo.vue?macro=true";
import { default as snowmobileqwBMJczArgItcCvnDpw9FFszlqE_45j39lQlByWLukzGoMeta } from "/var/www/2025-07-29_16_32/pages/shippingtypes/snowmobile.vue?macro=true";
import { default as indexO7HeAfVNW4vfC5Bq2e_45s0sJJbwcgdgRCQ6b0cx95FTcMeta } from "/var/www/2025-07-29_16_32/pages/iframe/order/create/index.vue?macro=true";
import { default as yandex_45market3_18KVF3ECWoHVujif4s08RcaUH0HUZoV6ZsROvzdJQMeta } from "/var/www/2025-07-29_16_32/pages/marketplace/yandex-market.vue?macro=true";
import { default as templates4Y2fiHgNby_9r8y1obN1jmW7eJzOEk1ixIIV4FrmpA8Meta } from "/var/www/2025-07-29_16_32/pages/personal/orders/templates.vue?macro=true";
import { default as indexFu7grjDIZjKU5Hf_MYKGv7xowSi2XYJmXfuKlO0IQPcMeta } from "/var/www/2025-07-29_16_32/pages/personal/contractors/index.vue?macro=true";
import { default as refrigeratoric2dVLGuVbcPpOGJWI8crdwgPgUa37DbcHCjCamUn48Meta } from "/var/www/2025-07-29_16_32/pages/shippingtypes/refrigerator.vue?macro=true";
import { default as _91guid_93Z7dPeC6ZOGmXKRb3T2XJ5_BurCd8LsXniKATQ8jyIV8Meta } from "/var/www/2025-07-29_16_32/pages/personal/contractors/[guid].vue?macro=true";
import { default as index8NSGO_c7YwFzYnlU9bOmeNbxbexeVjxCK8ZMuKBVo_cMeta } from "/var/www/2025-07-29_16_32/pages/personal/multi-pickup/index.vue?macro=true";
import { default as _91guid_93M8dTjbYX7G_45yhe6YytXtPqoqywZdsZrw9OeeUB1Bak0Meta } from "/var/www/2025-07-29_16_32/pages/personal/multi-pickup/[guid].vue?macro=true";
import { default as consumer_45goodsZ9Racv5RR1vg_Mbk8vHLG1LFu0J1IlDg8RBIEbTlPXYMeta } from "/var/www/2025-07-29_16_32/pages/shippingtypes/consumer-goods.vue?macro=true";
import { default as indexE8nDpshcW7Qlc2LZSunEOaGzkmYvnjkC_45yRq8ZVqxDYMeta } from "/var/www/2025-07-29_16_32/pages/personal/group-printing/index.vue?macro=true";
import { default as index6G_u06UeapSXiSTuNgJ1pLhCmsMfLHAnkWQhamAqn_gMeta } from "/var/www/2025-07-29_16_32/pages/personal/multi-delivery/index.vue?macro=true";
import { default as medical_45deviceseTyYq0bleYBReCM_ugl3xTKD7qQIllLYAAgKRmmrCycMeta } from "/var/www/2025-07-29_16_32/pages/shippingtypes/medical-devices.vue?macro=true";
import { default as _91guid_93qa1qZ7L6PjfglukjK9o5_FC34IENnNkvyDTtM2pBiRkMeta } from "/var/www/2025-07-29_16_32/pages/iframe/order/administer/[guid].vue?macro=true";
import { default as _91guid_93_45kO_cGvp6cEyycPKRu6lUYy5FMaDwmmto3r18KJF2DIMeta } from "/var/www/2025-07-29_16_32/pages/personal/multi-delivery/[guid].vue?macro=true";
import { default as _91_46_46_46id_93xXgKd0YHqTNPwvtrIXWV04ngPmKen9kq5XcPpkOEYloMeta } from "/var/www/2025-07-29_16_32/pages/personal/order/template/[...id].vue?macro=true";
import { default as special_45equipmentbCJzAhpABrSqmaDzzBMF1v_45Hc0CXSWjB4RiLAYXwy34Meta } from "/var/www/2025-07-29_16_32/pages/shippingtypes/special-equipment.vue?macro=true";
import { default as building_45materialsuPETVLqSps7EcRq8DlU1USr4MT4ucUAqvK80PFaQ4JQMeta } from "/var/www/2025-07-29_16_32/pages/shippingtypes/building-materials.vue?macro=true";
import { default as musical_45instruments_vs40s9OjLAGtTMCr_45FIZJg14CZKfALOq6cr3kbCH8kMeta } from "/var/www/2025-07-29_16_32/pages/shippingtypes/musical-instruments.vue?macro=true";
import { default as industrial_45equipmentf6uFNVf9218Btmttlb0Gp3A__I1KE8GtoMnZlAEeYz0Meta } from "/var/www/2025-07-29_16_32/pages/shippingtypes/industrial-equipment.vue?macro=true";
import { default as motorcycletransportationACHmqbhd3Z3TMHHonBdt3f_TPPTYuA1nyLtJxoHCSxIMeta } from "/var/www/2025-07-29_16_32/pages/shippingtypes/motorcycletransportation.vue?macro=true";
import { default as _91locationFrom_93__91locationTo_93pzq3ljd5iTbcc_iv5_458wxv1HTx44P0lQa2jVhUb4jRoMeta } from "/var/www/2025-07-29_16_32/pages/order/create/[locationFrom]_[locationTo].vue?macro=true";
import { default as personalitemstransportationn2_45Auw1FVxFxzgDXiqqi64kYG_458BlbXAZ__45OtFmCEosMeta } from "/var/www/2025-07-29_16_32/pages/shippingtypes/personalitemstransportation.vue?macro=true";
export default [
  {
    name: "edo",
    path: "/edo",
    component: () => import("/var/www/2025-07-29_16_32/pages/edo.vue")
  },
  {
    name: "help",
    path: "/help",
    component: () => import("/var/www/2025-07-29_16_32/pages/help.vue")
  },
  {
    name: "cargo",
    path: "/cargo",
    component: () => import("/var/www/2025-07-29_16_32/pages/cargo.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/var/www/2025-07-29_16_32/pages/index.vue")
  },
  {
    name: "slug",
    path: "/:slug()",
    meta: _91slug_93fAERDOk_45c3bxD9AgyRVrA2pC_LKcLRz0OyLdgAIWgQYMeta || {},
    component: () => import("/var/www/2025-07-29_16_32/pages/[slug].vue")
  },
  {
    name: "cookie",
    path: "/cookie",
    component: () => import("/var/www/2025-07-29_16_32/pages/cookie.vue")
  },
  {
    name: "survey",
    path: "/survey/:surveyId/",
    meta: surveypDJQ8mwLQeCOJ_45dKqasE0DfLvMDizjPimbS6oTD4A_45MMeta || {},
    component: () => import("/var/www/2025-07-29_16_32/pages/survey.vue")
  },
  {
    name: "belarus",
    path: "/belarus",
    component: () => import("/var/www/2025-07-29_16_32/pages/belarus.vue")
  },
  {
    name: "bonuses",
    path: "/bonuses",
    component: () => import("/var/www/2025-07-29_16_32/pages/bonuses.vue")
  },
  {
    name: "dev-api",
    path: "/dev/api",
    component: () => import("/var/www/2025-07-29_16_32/pages/dev/api.vue")
  },
  {
    name: "dev-cms",
    path: "/dev/cms",
    component: () => import("/var/www/2025-07-29_16_32/pages/dev/cms.vue")
  },
  {
    name: "konkurs",
    path: "/konkurs",
    meta: konkursPhMaiSfuUaO_wecgp9bE_OXYiLYUkhuLQIZV_45T4yIfEMeta || {},
    component: () => import("/var/www/2025-07-29_16_32/pages/konkurs.vue")
  },
  {
    name: "success",
    path: "/success",
    component: () => import("/var/www/2025-07-29_16_32/pages/success.vue")
  },
  {
    name: "vacancy",
    path: "/vacancy",
    component: () => import("/var/www/2025-07-29_16_32/pages/vacancy.vue")
  },
  {
    name: "contacts",
    path: "/:tag(address|contacts)/:location?",
    meta: contactsoCxutnBEJB96cl69gYPgd7Gn1HaucrpXVnjmQiUKjIkMeta || {},
    component: () => import("/var/www/2025-07-29_16_32/pages/contacts.vue")
  },
  {
    name: "giveaway",
    path: "/giveaway",
    component: () => import("/var/www/2025-07-29_16_32/pages/giveaway.vue")
  },
  {
    name: "guide-lk",
    path: "/guide-lk",
    component: () => import("/var/www/2025-07-29_16_32/pages/guide-lk.vue")
  },
  {
    name: "services",
    path: "/services",
    component: () => import("/var/www/2025-07-29_16_32/pages/services.vue")
  },
  {
    name: "telegram",
    path: "/telegram",
    component: () => import("/var/www/2025-07-29_16_32/pages/telegram.vue")
  },
  {
    name: "documents",
    path: "/documents",
    component: () => import("/var/www/2025-07-29_16_32/pages/documents.vue")
  },
  {
    name: "franchise",
    path: "/franchise",
    component: () => import("/var/www/2025-07-29_16_32/pages/franchise.vue")
  },
  {
    name: "insurance",
    path: "/insurance",
    component: () => import("/var/www/2025-07-29_16_32/pages/insurance.vue")
  },
  {
    name: "kirghizia",
    path: "/kirghizia",
    component: () => import("/var/www/2025-07-29_16_32/pages/kirghizia.vue")
  },
  {
    name: "mapScheme",
    path: "/mapScheme",
    meta: mapSchemeu_IZCff2E1EIBWxq5d1qRPuTI5Gdkd_45ZXcFod6rKuTcMeta || {},
    component: () => import("/var/www/2025-07-29_16_32/pages/mapScheme.vue")
  },
  {
    name: "news-id",
    path: "/:tag(news|actions)/:id",
    meta: _91id_93yIdeObKT8rn4JbFTVE70BlDCLXjAKEkeQT6e0i20eWAMeta || {},
    component: () => import("/var/www/2025-07-29_16_32/pages/news/[id].vue")
  },
  {
    name: "return-sd",
    path: "/return-sd",
    component: () => import("/var/www/2025-07-29_16_32/pages/return-sd.vue")
  },
  {
    name: "smsClient",
    path: "/smsClient",
    component: () => import("/var/www/2025-07-29_16_32/pages/smsClient.vue")
  },
  {
    name: "terminals",
    path: "/terminals",
    component: () => import("/var/www/2025-07-29_16_32/pages/terminals.vue")
  },
  {
    name: "dev-iframe",
    path: "/dev/iframe",
    component: () => import("/var/www/2025-07-29_16_32/pages/dev/iframe.vue")
  },
  {
    name: "directions",
    path: "/directions",
    component: () => import("/var/www/2025-07-29_16_32/pages/directions.vue")
  },
  {
    name: "kazakhstan",
    path: "/kazakhstan",
    component: () => import("/var/www/2025-07-29_16_32/pages/kazakhstan.vue")
  },
  {
    name: "news",
    path: "/:tag(news|actions)",
    meta: indexhiLXTsq_bK6LL2i6AUW_450Uu_tHf3oKgLTfHasHRTiWwMeta || {},
    component: () => import("/var/www/2025-07-29_16_32/pages/news/index.vue")
  },
  {
    name: "ui-kit-svg",
    path: "/ui-kit/svg",
    component: () => import("/var/www/2025-07-29_16_32/pages/ui-kit/svg.vue")
  },
  {
    name: "vzpay-fail",
    path: "/vzpay-fail",
    component: () => import("/var/www/2025-07-29_16_32/pages/vzpay-fail.vue")
  },
  {
    name: "constructor",
    path: "/constructor",
    meta: constructorIeMOLuS8oh8LSfNz0xwZHlx3rlr2yt6i7pl5tNZzBUMMeta || {},
    component: () => import("/var/www/2025-07-29_16_32/pages/constructor.vue")
  },
  {
    name: "gifts",
    path: "/gifts",
    meta: indexG5uEdfK9D_Yk5cjyjTOS58x15o7501dmKmg2JVR974QMeta || {},
    component: () => import("/var/www/2025-07-29_16_32/pages/gifts/index.vue")
  },
  {
    name: "information",
    path: "/information",
    component: () => import("/var/www/2025-07-29_16_32/pages/information.vue")
  },
  {
    name: "order-light",
    path: "/order/light",
    component: () => import("/var/www/2025-07-29_16_32/pages/order/light.vue")
  },
  {
    name: "claim-filing",
    path: "/claim-filing",
    component: () => import("/var/www/2025-07-29_16_32/pages/claim-filing.vue")
  },
  {
    name: "gifts-type",
    path: "/gift/:type(m|o)",
    meta: _91type_93MR5j4_FG4golKFvZp5j2ACTVf6zTq_45x4MwGqKb56VHYMeta || {},
    component: () => import("/var/www/2025-07-29_16_32/pages/gifts/[type].vue")
  },
  {
    name: "marketplaces",
    path: "/marketplaces",
    component: () => import("/var/www/2025-07-29_16_32/pages/marketplaces.vue")
  },
  {
    name: "networkshops",
    path: "/networkshops",
    component: () => import("/var/www/2025-07-29_16_32/pages/networkshops.vue")
  },
  {
    name: "online-store",
    path: "/online-store",
    component: () => import("/var/www/2025-07-29_16_32/pages/online-store.vue")
  },
  {
    name: "order-manage",
    path: "/order/manage",
    component: () => import("/var/www/2025-07-29_16_32/pages/order/manage.vue")
  },
  {
    name: "registration",
    path: "/registration",
    component: () => import("/var/www/2025-07-29_16_32/pages/registration.vue")
  },
  {
    name: "safe-custody",
    path: "/safe-custody",
    component: () => import("/var/www/2025-07-29_16_32/pages/safe-custody.vue")
  },
  {
    name: "ui-kit-image",
    path: "/ui-kit/image",
    component: () => import("/var/www/2025-07-29_16_32/pages/ui-kit/image.vue")
  },
  {
    name: "ui-kit",
    path: "/ui-kit",
    component: () => import("/var/www/2025-07-29_16_32/pages/ui-kit/index.vue")
  },
  {
    name: "wrapping-bag",
    path: "/wrapping/bag",
    component: () => import("/var/www/2025-07-29_16_32/pages/wrapping/bag.vue")
  },
  {
    name: "wrapping-box",
    path: "/wrapping/box",
    component: () => import("/var/www/2025-07-29_16_32/pages/wrapping/box.vue")
  },
  {
    name: "cargo-loading",
    path: "/cargo-loading",
    component: () => import("/var/www/2025-07-29_16_32/pages/cargo-loading.vue")
  },
  {
    name: "happybirthday",
    path: "/happybirthday",
    meta: happybirthdayhDIxfB6kNBAkddKjPvduZ00jaxp_b4Cd_45zndrlmxXm4Meta || {},
    component: () => import("/var/www/2025-07-29_16_32/pages/happybirthday.vue")
  },
  {
    name: "iframe-manage",
    path: "/iframe/manage",
    meta: manageYrSUTMTPGqYrjp_eI8qQCl9QXP8Huj5TQBtT_oQn_lsMeta || {},
    component: () => import("/var/www/2025-07-29_16_32/pages/iframe/manage.vue")
  },
  {
    name: "personal-auth",
    path: "/personal/auth",
    component: () => import("/var/www/2025-07-29_16_32/pages/personal/auth.vue")
  },
  {
    name: "tariffs",
    path: "/tariffs",
    component: () => import("/var/www/2025-07-29_16_32/pages/tariffs/index.vue")
  },
  {
    name: "ui-kit-public",
    path: "/ui-kit/public",
    component: () => import("/var/www/2025-07-29_16_32/pages/ui-kit/public.vue")
  },
  {
    name: "already-answer",
    path: "/already-answer",
    component: () => import("/var/www/2025-07-29_16_32/pages/already-answer.vue")
  },
  {
    name: "iframe-tariffs",
    path: "/iframe/tariffs",
    meta: tariffs7NXaEdMWmlxmiKR2cyqwE_45_4552uAXn_xwX7uui4nsht4Meta || {},
    component: () => import("/var/www/2025-07-29_16_32/pages/iframe/tariffs.vue")
  },
  {
    name: "order-pay-id",
    path: "/order/pay/:id()",
    component: () => import("/var/www/2025-07-29_16_32/pages/order/pay/[id].vue")
  },
  {
    name: "personal",
    path: "/personal",
    meta: indexwDDjgMf2rnQ_4Fr7iK918a_45ZEwmJ58m8iSgBnQC4k3IMeta || {},
    component: () => import("/var/www/2025-07-29_16_32/pages/personal/index.vue")
  },
  {
    name: "welcome-hash",
    path: "/welcome/:hash()",
    component: () => import("/var/www/2025-07-29_16_32/pages/welcome/[hash].vue")
  },
  {
    name: "wrapping",
    path: "/wrapping",
    component: () => import("/var/www/2025-07-29_16_32/pages/wrapping/index.vue")
  },
  {
    name: "delivery-russia",
    path: "/delivery-russia",
    component: () => import("/var/www/2025-07-29_16_32/pages/delivery-russia.vue")
  },
  {
    name: "payment-methods",
    path: "/payment-methods",
    component: () => import("/var/www/2025-07-29_16_32/pages/payment-methods.vue")
  },
  {
    name: "payment-qr-info",
    path: "/payment/qr-info",
    component: () => import("/var/www/2025-07-29_16_32/pages/payment/qr-info.vue")
  },
  {
    name: "payment-success",
    path: "/payment/success",
    component: () => import("/var/www/2025-07-29_16_32/pages/payment/success.vue")
  },
  {
    name: "personal-import",
    path: "/personal/import",
    meta: importEvzengNLt30HbTtw7quj5tOQ6WSEzYBcDwYe0DW8Fu8Meta || {},
    component: () => import("/var/www/2025-07-29_16_32/pages/personal/import.vue")
  },
  {
    name: "personal-logout",
    path: "/personal/logout",
    meta: logoutj57kBWi4E9Rdd_jDMvorCaBf5OEbjbdVR_rHv183KUYMeta || {},
    component: () => import("/var/www/2025-07-29_16_32/pages/personal/logout.vue")
  },
  {
    name: "address-delivery",
    path: "/address-delivery",
    component: () => import("/var/www/2025-07-29_16_32/pages/address-delivery.vue")
  },
  {
    name: "cash-on-delivery",
    path: "/cash-on-delivery",
    component: () => import("/var/www/2025-07-29_16_32/pages/cash-on-delivery.vue")
  },
  {
    name: "happynewyear2024",
    path: "/happynewyear2024",
    meta: happynewyear20240gJTpL1tWKViEWF56Q7_45_45OSdv_45eDP1riNzPPx9bDvEcMeta || {},
    component: () => import("/var/www/2025-07-29_16_32/pages/happynewyear2024.vue")
  },
  {
    name: "marketplace-ozon",
    path: "/ozon",
    meta: ozonoinsdbviUj3Zo7H4UXUs2W6BDKDQPwOOyLqDWRYslZAMeta || {},
    component: () => import("/var/www/2025-07-29_16_32/pages/marketplace/ozon.vue")
  },
  {
    name: "payment-pay-fail",
    path: "/payment/pay-fail",
    component: () => import("/var/www/2025-07-29_16_32/pages/payment/pay-fail.vue")
  },
  {
    name: "personal-account",
    path: "/personal/account",
    meta: accountspeWv_tk78JdECWzem_z3KHrq299vLuTmBY00tfybM8Meta || {},
    component: () => import("/var/www/2025-07-29_16_32/pages/personal/account.vue")
  },
  {
    name: "prohibited-goods",
    path: "/prohibited-goods",
    component: () => import("/var/www/2025-07-29_16_32/pages/prohibited-goods.vue")
  },
  {
    name: "survey-completed",
    path: "/survey-completed",
    meta: survey_45completedfYWr5whuVinx8d6M_45ijZJUhigdGRWk7OT6E_6ZclmtAMeta || {},
    component: () => import("/var/www/2025-07-29_16_32/pages/survey-completed.vue")
  },
  {
    name: "ui-kit-direction",
    path: "/ui-kit/direction",
    component: () => import("/var/www/2025-07-29_16_32/pages/ui-kit/direction.vue")
  },
  {
    name: "free-group-pickup",
    path: "/free-group-pickup",
    component: () => import("/var/www/2025-07-29_16_32/pages/free-group-pickup.vue")
  },
  {
    name: "free-pickup-cargo",
    path: "/free-pickup-cargo",
    component: () => import("/var/www/2025-07-29_16_32/pages/free-pickup-cargo.vue")
  },
  {
    name: "iframe-calculator",
    path: "/iframe/calculator",
    meta: calculatorxYLEH9HcwxmaYJuT45SbiOrdoROCYwy3DtABEuBEgGQMeta || {},
    component: () => import("/var/www/2025-07-29_16_32/pages/iframe/calculator.vue")
  },
  {
    name: "merch-for-bonuses",
    path: "/merch-for-bonuses",
    component: () => import("/var/www/2025-07-29_16_32/pages/merch-for-bonuses.vue")
  },
  {
    name: "order-pay-qr-id",
    path: "/order/pay/qr/:id()",
    component: () => import("/var/www/2025-07-29_16_32/pages/order/pay/qr/[id].vue")
  },
  {
    name: "payment-card-info",
    path: "/payment/card-info",
    component: () => import("/var/www/2025-07-29_16_32/pages/payment/card-info.vue")
  },
  {
    name: "personal-discount",
    path: "/personal/discount",
    meta: discount41O_45F57cLWNumuqzam6NiEsaeGKGRlP3saRG5pBnvgcMeta || {},
    component: () => import("/var/www/2025-07-29_16_32/pages/personal/discount.vue")
  },
  {
    name: "wrapping-hard-box",
    path: "/wrapping/hard-box",
    component: () => import("/var/www/2025-07-29_16_32/pages/wrapping/hard-box.vue")
  },
  {
    name: "forwarding-receipt",
    path: "/forwarding-receipt",
    component: () => import("/var/www/2025-07-29_16_32/pages/forwarding-receipt.vue")
  },
  {
    name: "mailClient10201917",
    path: "/mailClient10201917",
    meta: mailClient10201917abPrDoDNkgRTS623gPKzKLE0nTgEx5jz27haA_45wnd50Meta || {},
    component: () => import("/var/www/2025-07-29_16_32/pages/mailClient10201917.vue")
  },
  {
    name: "mobile-application",
    path: "/mobile-application",
    component: () => import("/var/www/2025-07-29_16_32/pages/mobile-application.vue")
  },
  {
    name: "order-create",
    path: "/order/create",
    meta: indexEq3kCuOjTxuWTZgW_dUHf8A6SZCcBI0bCLuWFYUoXU8Meta || {},
    component: () => import("/var/www/2025-07-29_16_32/pages/order/create/index.vue")
  },
  {
    name: "run-schedule",
    path: "/run-schedule",
    component: () => import("/var/www/2025-07-29_16_32/pages/run-schedule/index.vue")
  },
  {
    name: "shippingtypes-boat",
    path: "/shippingtypes/boat",
    component: () => import("/var/www/2025-07-29_16_32/pages/shippingtypes/boat.vue")
  },
  {
    name: "shippingtypes-sofa",
    path: "/shippingtypes/sofa",
    component: () => import("/var/www/2025-07-29_16_32/pages/shippingtypes/sofa.vue")
  },
  {
    name: "tariffs-location",
    path: "/tariffs/:location()",
    component: () => import("/var/www/2025-07-29_16_32/pages/tariffs/[location].vue")
  },
  {
    name: "wrapping-cardboard",
    path: "/wrapping/cardboard",
    component: () => import("/var/www/2025-07-29_16_32/pages/wrapping/cardboard.vue")
  },
  {
    name: "personal-promocodes",
    path: "/personal/promocodes",
    meta: promocodesi7D4vzz2QJOeD5DHNVTvDirmiqHM3gSDDqJWjSG1REMMeta || {},
    component: () => import("/var/www/2025-07-29_16_32/pages/personal/promocodes.vue")
  },
  {
    name: "shippingtypes-bench",
    path: "/shippingtypes/bench",
    component: () => import("/var/www/2025-07-29_16_32/pages/shippingtypes/bench.vue")
  },
  {
    name: "shippingtypes-books",
    path: "/shippingtypes/books",
    component: () => import("/var/www/2025-07-29_16_32/pages/shippingtypes/books.vue")
  },
  {
    name: "shippingtypes-cable",
    path: "/shippingtypes/cable",
    component: () => import("/var/www/2025-07-29_16_32/pages/shippingtypes/cable.vue")
  },
  {
    name: "shippingtypes-chair",
    path: "/shippingtypes/chair",
    component: () => import("/var/www/2025-07-29_16_32/pages/shippingtypes/chair.vue")
  },
  {
    name: "shippingtypes-goods",
    path: "/shippingtypes/goods",
    component: () => import("/var/www/2025-07-29_16_32/pages/shippingtypes/goods.vue")
  },
  {
    name: "shippingtypes",
    path: "/shippingtypes",
    component: () => import("/var/www/2025-07-29_16_32/pages/shippingtypes/index.vue")
  },
  {
    name: "shippingtypes-metal",
    path: "/shippingtypes/metal",
    component: () => import("/var/www/2025-07-29_16_32/pages/shippingtypes/metal.vue")
  },
  {
    name: "shippingtypes-piano",
    path: "/shippingtypes/piano",
    component: () => import("/var/www/2025-07-29_16_32/pages/shippingtypes/piano.vue")
  },
  {
    name: "shippingtypes-pipes",
    path: "/shippingtypes/pipes",
    component: () => import("/var/www/2025-07-29_16_32/pages/shippingtypes/pipes.vue")
  },
  {
    name: "shippingtypes-tools",
    path: "/shippingtypes/tools",
    component: () => import("/var/www/2025-07-29_16_32/pages/shippingtypes/tools.vue")
  },
  {
    name: "wrapping-pallet-box",
    path: "/wrapping/pallet-box",
    component: () => import("/var/www/2025-07-29_16_32/pages/wrapping/pallet-box.vue")
  },
  {
    name: "personal-bonus-tab",
    path: "/personal/bonus/:tab()",
    meta: _91tab_933qCBhm_4d_kzsVyCzI96mjUgdGw8zin0I3rbexuD5IUMeta || {},
    component: () => import("/var/www/2025-07-29_16_32/pages/personal/bonus/[tab].vue")
  },
  {
    name: "personal-order-print",
    path: "/personal/order/print",
    meta: print9ZYYT_tpcpq8MbsvsaAhHH8XwxpT60T5V2MjZF46_78Meta || {},
    component: () => import("/var/www/2025-07-29_16_32/pages/personal/order/print.vue")
  },
  {
    name: "shippingtypes-dishes",
    path: "/shippingtypes/dishes",
    component: () => import("/var/www/2025-07-29_16_32/pages/shippingtypes/dishes.vue")
  },
  {
    name: "shippingtypes-engine",
    path: "/shippingtypes/engine",
    component: () => import("/var/www/2025-07-29_16_32/pages/shippingtypes/engine.vue")
  },
  {
    name: "shippingtypes-lumber",
    path: "/shippingtypes/lumber",
    component: () => import("/var/www/2025-07-29_16_32/pages/shippingtypes/lumber.vue")
  },
  {
    name: "shippingtypes-wheels",
    path: "/shippingtypes/wheels",
    component: () => import("/var/www/2025-07-29_16_32/pages/shippingtypes/wheels.vue")
  },
  {
    name: "wrapping-bubble-film",
    path: "/wrapping/bubble-film",
    component: () => import("/var/www/2025-07-29_16_32/pages/wrapping/bubble-film.vue")
  },
  {
    name: "wrapping-palletising",
    path: "/wrapping/palletising",
    component: () => import("/var/www/2025-07-29_16_32/pages/wrapping/palletising.vue")
  },
  {
    name: "fast-delivery-capital",
    path: "/fast-delivery-capital",
    component: () => import("/var/www/2025-07-29_16_32/pages/fast-delivery-capital.vue")
  },
  {
    name: "personal-order-guid",
    path: "/personal/order/:tag(pay)?/:guid",
    meta: _91guid_93BGQ6znANQ9GjdsNFtn3EuW5mZewyDa_fQjdDnxZJ5wgMeta || {},
    component: () => import("/var/www/2025-07-29_16_32/pages/personal/order/[guid].vue")
  },
  {
    name: "personal-order-create",
    path: "/personal/order/create",
    meta: createpvDxW9cthosJv6hQFPSZNI8d2rsq5fvxrpuTKprmlO0Meta || {},
    component: () => import("/var/www/2025-07-29_16_32/pages/personal/order/create.vue")
  },
  {
    name: "shippingtypes-barrels",
    path: "/shippingtypes/barrels",
    component: () => import("/var/www/2025-07-29_16_32/pages/shippingtypes/barrels.vue")
  },
  {
    name: "shippingtypes-clothes",
    path: "/shippingtypes/clothes",
    component: () => import("/var/www/2025-07-29_16_32/pages/shippingtypes/clothes.vue")
  },
  {
    name: "shippingtypes-fragile",
    path: "/shippingtypes/fragile",
    component: () => import("/var/www/2025-07-29_16_32/pages/shippingtypes/fragile.vue")
  },
  {
    name: "shippingtypes-trailer",
    path: "/shippingtypes/trailer",
    component: () => import("/var/www/2025-07-29_16_32/pages/shippingtypes/trailer.vue")
  },
  {
    name: "wrapping-safe-package",
    path: "/wrapping/safe-package",
    component: () => import("/var/www/2025-07-29_16_32/pages/wrapping/safe-package.vue")
  },
  {
    name: "payment-bepaid-success",
    path: "/payment/bepaid-success",
    component: () => import("/var/www/2025-07-29_16_32/pages/payment/bepaid-success.vue")
  },
  {
    name: "wrapping-extra-package",
    path: "/wrapping/extra-package",
    component: () => import("/var/www/2025-07-29_16_32/pages/wrapping/extra-package.vue")
  },
  {
    name: "marketplace-wildberries",
    path: "/wildberries",
    meta: wildberriesQ86lvCGBXkTXWEdVDiB9VgaRkk7BJlNjwJxPcUqn0gcMeta || {},
    component: () => import("/var/www/2025-07-29_16_32/pages/marketplace/wildberries.vue")
  },
  {
    name: "order-administer-guid",
    path: "/order/administer/:guid()",
    component: () => import("/var/www/2025-07-29_16_32/pages/order/administer/[guid].vue")
  },
  {
    name: "run-schedule-location",
    path: "/run-schedule/:location()",
    component: () => import("/var/www/2025-07-29_16_32/pages/run-schedule/[location].vue")
  },
  {
    name: "shippingtypes-furniture",
    path: "/shippingtypes/furniture",
    component: () => import("/var/www/2025-07-29_16_32/pages/shippingtypes/furniture.vue")
  },
  {
    name: "shippingtypes-oversized",
    path: "/shippingtypes/oversized",
    component: () => import("/var/www/2025-07-29_16_32/pages/shippingtypes/oversized.vue")
  },
  {
    name: "shippingtypes-quad-bike",
    path: "/shippingtypes/quad-bike",
    component: () => import("/var/www/2025-07-29_16_32/pages/shippingtypes/quad-bike.vue")
  },
  {
    name: "order-create-locations",
    path: "/order/create/:locations()",
    component: () => import("/var/www/2025-07-29_16_32/pages/order/create/[locations].vue")
  },
  {
    name: "personal-orders-tab",
    path: "/personal/orders/:tab(.*)*",
    meta: _91_46_46_46tab_9345WVe7o4nlVUFz0w4708weB2_P_45nhE1jCqQOQ50e9kgMeta || {},
    component: () => import("/var/www/2025-07-29_16_32/pages/personal/orders/[...tab].vue")
  },
  {
    name: "shippingtypes-auto-parts",
    path: "/shippingtypes/auto-parts",
    component: () => import("/var/www/2025-07-29_16_32/pages/shippingtypes/auto-parts.vue")
  },
  {
    name: "shippingtypes-newspapers",
    path: "/shippingtypes/newspapers",
    component: () => import("/var/www/2025-07-29_16_32/pages/shippingtypes/newspapers.vue")
  },
  {
    name: "shippingtypes-smallcargo",
    path: "/shippingtypes/smallcargo",
    component: () => import("/var/www/2025-07-29_16_32/pages/shippingtypes/smallcargo.vue")
  },
  {
    name: "shippingtypes-snowmobile",
    path: "/shippingtypes/snowmobile",
    component: () => import("/var/www/2025-07-29_16_32/pages/shippingtypes/snowmobile.vue")
  },
  {
    name: "iframe-order-create",
    path: "/iframe/order/create",
    meta: indexO7HeAfVNW4vfC5Bq2e_45s0sJJbwcgdgRCQ6b0cx95FTcMeta || {},
    component: () => import("/var/www/2025-07-29_16_32/pages/iframe/order/create/index.vue")
  },
  {
    name: "marketplace-yandex-market",
    path: "/yandex-market",
    meta: yandex_45market3_18KVF3ECWoHVujif4s08RcaUH0HUZoV6ZsROvzdJQMeta || {},
    component: () => import("/var/www/2025-07-29_16_32/pages/marketplace/yandex-market.vue")
  },
  {
    name: "personal-orders-templates",
    path: "/personal/orders/templates",
    meta: templates4Y2fiHgNby_9r8y1obN1jmW7eJzOEk1ixIIV4FrmpA8Meta || {},
    component: () => import("/var/www/2025-07-29_16_32/pages/personal/orders/templates.vue")
  },
  {
    name: "personal-contractors",
    path: "/personal/contractors",
    meta: indexFu7grjDIZjKU5Hf_MYKGv7xowSi2XYJmXfuKlO0IQPcMeta || {},
    component: () => import("/var/www/2025-07-29_16_32/pages/personal/contractors/index.vue")
  },
  {
    name: "shippingtypes-refrigerator",
    path: "/shippingtypes/refrigerator",
    component: () => import("/var/www/2025-07-29_16_32/pages/shippingtypes/refrigerator.vue")
  },
  {
    name: "personal-contractors-guid",
    path: "/personal/contractors/:guid()",
    meta: _91guid_93Z7dPeC6ZOGmXKRb3T2XJ5_BurCd8LsXniKATQ8jyIV8Meta || {},
    component: () => import("/var/www/2025-07-29_16_32/pages/personal/contractors/[guid].vue")
  },
  {
    name: "personal-multi-pickup",
    path: "/personal/multi-pickup",
    meta: index8NSGO_c7YwFzYnlU9bOmeNbxbexeVjxCK8ZMuKBVo_cMeta || {},
    component: () => import("/var/www/2025-07-29_16_32/pages/personal/multi-pickup/index.vue")
  },
  {
    name: "personal-multi-pickup-guid",
    path: "/personal/multi-pickup/:guid",
    meta: _91guid_93M8dTjbYX7G_45yhe6YytXtPqoqywZdsZrw9OeeUB1Bak0Meta || {},
    component: () => import("/var/www/2025-07-29_16_32/pages/personal/multi-pickup/[guid].vue")
  },
  {
    name: "shippingtypes-consumer-goods",
    path: "/shippingtypes/consumer-goods",
    component: () => import("/var/www/2025-07-29_16_32/pages/shippingtypes/consumer-goods.vue")
  },
  {
    name: "personal-group-printing",
    path: "/personal/group-printing",
    meta: indexE8nDpshcW7Qlc2LZSunEOaGzkmYvnjkC_45yRq8ZVqxDYMeta || {},
    component: () => import("/var/www/2025-07-29_16_32/pages/personal/group-printing/index.vue")
  },
  {
    name: "personal-multi-delivery",
    path: "/personal/multi-delivery",
    meta: index6G_u06UeapSXiSTuNgJ1pLhCmsMfLHAnkWQhamAqn_gMeta || {},
    component: () => import("/var/www/2025-07-29_16_32/pages/personal/multi-delivery/index.vue")
  },
  {
    name: "shippingtypes-medical-devices",
    path: "/shippingtypes/medical-devices",
    component: () => import("/var/www/2025-07-29_16_32/pages/shippingtypes/medical-devices.vue")
  },
  {
    name: "iframe-order-administer-guid",
    path: "/iframe/order/administer/:guid()",
    meta: _91guid_93qa1qZ7L6PjfglukjK9o5_FC34IENnNkvyDTtM2pBiRkMeta || {},
    component: () => import("/var/www/2025-07-29_16_32/pages/iframe/order/administer/[guid].vue")
  },
  {
    name: "personal-multi-delivery-guid",
    path: "/personal/multi-delivery/:guid",
    meta: _91guid_93_45kO_cGvp6cEyycPKRu6lUYy5FMaDwmmto3r18KJF2DIMeta || {},
    component: () => import("/var/www/2025-07-29_16_32/pages/personal/multi-delivery/[guid].vue")
  },
  {
    name: "personal-order-template-id",
    path: "/personal/order/template/:id(.*)*",
    meta: _91_46_46_46id_93xXgKd0YHqTNPwvtrIXWV04ngPmKen9kq5XcPpkOEYloMeta || {},
    component: () => import("/var/www/2025-07-29_16_32/pages/personal/order/template/[...id].vue")
  },
  {
    name: "shippingtypes-special-equipment",
    path: "/shippingtypes/special-equipment",
    component: () => import("/var/www/2025-07-29_16_32/pages/shippingtypes/special-equipment.vue")
  },
  {
    name: "shippingtypes-building-materials",
    path: "/shippingtypes/building-materials",
    component: () => import("/var/www/2025-07-29_16_32/pages/shippingtypes/building-materials.vue")
  },
  {
    name: "shippingtypes-musical-instruments",
    path: "/shippingtypes/musical-instruments",
    component: () => import("/var/www/2025-07-29_16_32/pages/shippingtypes/musical-instruments.vue")
  },
  {
    name: "shippingtypes-industrial-equipment",
    path: "/shippingtypes/industrial-equipment",
    component: () => import("/var/www/2025-07-29_16_32/pages/shippingtypes/industrial-equipment.vue")
  },
  {
    name: "shippingtypes-motorcycletransportation",
    path: "/shippingtypes/motorcycletransportation",
    component: () => import("/var/www/2025-07-29_16_32/pages/shippingtypes/motorcycletransportation.vue")
  },
  {
    name: "order-create-locationFrom_locationTo",
    path: "/order/create/:locationFrom()_:locationTo()",
    component: () => import("/var/www/2025-07-29_16_32/pages/order/create/[locationFrom]_[locationTo].vue")
  },
  {
    name: "shippingtypes-personalitemstransportation",
    path: "/shippingtypes/personalitemstransportation",
    component: () => import("/var/www/2025-07-29_16_32/pages/shippingtypes/personalitemstransportation.vue")
  }
]